import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesResRoutes } from '@conf/routes.config';
import { SupportComponent, SupportModalBlockComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-seat-attribute-test',
  templateUrl: './seat-attribute-request-test.component.html',
  styleUrls: ['./seat-attribute-test.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeatAttributeTestComponent extends SupportComponent implements OnInit {
  public text = '';

  reload(): void {}
  init(): void {}
  destroy(): void {}

  constructor(private _common: CommonLibService, private _router: Router) {
    super(_common);
  }

  seatAttributeTest1() {
    this._router.navigateByUrl(RoutesResRoutes.SEAT_ATTRIBUTE_REQUEST);
  }
}
